import { Components } from "appworks/components/components";
import { Layers } from "appworks/graphics/layers/layers";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { slotDefinition } from "slotworks/model/slot-definition";

export function ChangeMatrixCommand(freespins: boolean = false) {

    const scene = freespins ? "freespins" : "default";

    const layers: Layers[] = [
        Layers.get("MatrixBackground"),
        Layers.get("MatrixContent"),
        Layers.get("MatrixForeground"),
        Layers.get("SymbolAnimations")
    ];

    layers.forEach((layer) => layer.hasScene(scene) && layer.setScene(scene).execute());

    const reelset = slotDefinition.reelsets.get(freespins ? "freespins" : "base");
    Components.get(MatrixComponent).setCustomReelset(reelset);
}
